<template>
  <div id="dashboardWrapper">
    <div class="columns">
      <div class="column">
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th class="has-fixed-width"></th>
              <th>Tijdstip</th>
              <th>Gebruiker</th>
              <th>Leverancier</th>
              <th>Verandering</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr
            v-for="notification in accountData.notifications"
            v-if="!notification.archived_at">
              <td>
                <span
                v-show="!notification.read_at"
                @click="read(notification.id)"
                class="tag is-primary">Nieuw</span>
              </td>
              <td>{{ notification.created_at }}</td>
              <td>{{ notification.data.user.firstname }} {{ notification.data.user.lastname }}</td>
              <td>{{ notification.data.supplier.name }}</td>
              <td>{{ notification.data.message }}: {{ (notification.data.item.name) ? notification.data.item.name : notification.data.item.title }}</td>
              <td>
                <button class="button" @click="archive(notification.id)">
                  <span class="icon"><i class="fas fa-archive"></i></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
    computed: {
        accountData () {
            return this.$store.getters.accountData
        }
    },
    created () {
        this.$store.dispatch('getAccountData')
    },
    methods: {
        read (notificationId) {
            axios.put(
                `auth/user/notifications/read/${notificationId}`
            ).then(
                (res) => {
                    this.$store.commit('READ_NOTIFICATION', res.data)
                }
            ).catch(
                (err) => {
                    console.error(err)
                }
            )
        },
        archive (notificationId) {
            axios.put(
                `auth/user/notifications/archive/${notificationId}`
            ).then(
                (res) => {
                    this.$store.commit('ARCHIVE_NOTIFICATION', res.data)
                }
            ).catch(
                (err) => {
                    console.error(err)
                }
            )
        }
    }
}
</script>

<style>
    .has-fixed-width {
        width: 5rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/users/Dashboard.vue